export default "__VITE_ASSET__24dc63dd__"